<template>
    <div id="duplicate-claim-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Possible Duplicate Claim</h5>
                </div>
                <div class="modal-body">      
                    <div class="d-flex">
                        <div><i class="fas fa-exclamation-triangle text-warning"></i></div>
                        <div class="warning-message ml-2">
                            {{ message }}
                            Please ensure you are not duplicating an existing claim.
                        </div>                          
                    </div>                    
                    <div v-if="claims.length">
                        <div class="mt-3 border-bottom">
                            <span class="heading">{{ title }}</span> 
                            <span class="text-muted font-italic"><small>(Click patient name link to navigate to claim)</small></span>
                        </div>
                        <table class="table table-sm table-hover table-borderless font-small">
                            <thead>
                                <tr class="text-muted">
                                    <th>Name</th>
                                    <th>Birth Date</th>
                                    <th>Injury Date</th>
                                    <th>Claim Number</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="claim in claims" :key="'duplicate-claim-' + claim.id" scope="row">
                                    <td :title="claim.patient_name"><a :href="getUrl(claim.id)">{{ claim.patient_name | truncate(20) }}</a></td>
                                    <td>{{ claim.dob }}</td>
                                    <td>{{ claim.injury_date }}</td>
                                    <td :title="claim.claim_number">{{ claim.claim_number| truncate(15) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <button v-if="allowContinue" type="button" class="btn btn-primary" @click="callback()" data-dismiss="modal">Continue</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>     
</template>

<script>
export default {
    data() {
        return {
            title: null,
            message: null,
            claims: [],
            allowContinue: true,          
            callback: null            
        }
    },
    methods: {
        show: function (title, message, claims, allowContinue, callback) {
            this.title = title;
            this.message = message;
            this.claims = claims;
            this.allowContinue = allowContinue;
            this.callback = callback;

            $('#duplicate-claim-modal').modal('show');            
        },
        getUrl: function (claimId) {
            return  new URL(window.location.origin + '/claims/' + claimId);
        }
    },
    created() {
        eventHub.$on('show-duplicate-claim-modal', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-duplicate-claim-modal');
    }    
}
</script>

<style scoped>
    .warning-message {
        font-weight: bold;
        font-size: 1rem;
    }

    .heading {
        font-size: 1.125rem;
    }

    .font-small {
        font-size: .75rem;
    }

    .table-sm th, .table-sm td {
        padding: 0.15rem !important;
    }
</style>